<template lang="pug">
header.header
  .header__inner
    .header__logo
      router-link(:to="'/design-base'", @click="navigate()") DESIGN BASE
        span
          | produced by
          em Orient Sailing Partners
    .header__description
      p 世の中の参考になるウェブサイトを集めました。
    .onoffswitch
      input#myonoffswitch.onoffswitch-checkbox(
        type="checkbox",
        name="onoffswitch",
        tabindex="0"
      )
      label.onoffswitch-label(for="myonoffswitch")
        span.onoffswitch-inner
        span.onoffswitch-switch
    nav.header-nav
      .header-nav__search
        button(type="submit")
          i.icon.ion-ios-search-strong
        input.search(v-model="query.title_cont")
  .header-filter
    ul
      li
        | 施設
        .selected
          i.icon.ion-arrow-down-b
          span(v-if="places_id_in.length") {{ places_id_in.length }}
        .menu
          .form-group(v-for="place in taxonomies.places")
            input.check_box(
              v-bind:id="place.id",
              type="checkbox",
              v-bind:value="place.id",
              v-model="places_id_in"
            )
            label(
              v-bind:for="place.id",
              v-bind:data-on-label="place.name",
              v-bind:data-off-label="place.name"
            )
              | {{ place.name }} ({{ place.indices_count }})
      li
        | 業種
        .selected
          i.icon.ion-arrow-down-b
          span(v-if="categories_id_in.length") {{ categories_id_in.length }}
        .menu
          .form-group(v-for="category in taxonomies.categories")
            input.check_box(
              v-bind:id="category.id",
              type="checkbox",
              v-bind:value="category.id",
              v-model="categories_id_in"
            )
            label(
              v-bind:for="category.id",
              v-bind:data-on-label="category.name",
              v-bind:data-off-label="category.name"
            )
              | {{ category.name }} ({{ category.indices_count }})
      li
        | カラー
        .selected
          i.icon.ion-arrow-down-b
          span(v-if="colors_id_in.length") {{ colors_id_in.length }}
        .menu
          .form-group(v-for="color in taxonomies.colors")
            input.check_box(
              v-bind:id="color.id",
              type="checkbox",
              v-bind:value="color.id",
              v-model="colors_id_in"
            )
            label(
              v-bind:for="color.id",
              v-bind:data-on-label="color.name",
              v-bind:data-off-label="color.name"
            )
              | {{ color.name }} ({{ color.indices_count }})
      li
        | 種類
        .selected
          i.icon.ion-arrow-down-b
          span(v-if="types_id_in.length") {{ types_id_in.length }}
        .menu
          .form-group(v-for="type in taxonomies.types")
            input.check_box(
              v-bind:id="type.id",
              type="checkbox",
              v-bind:value="type.id",
              v-model="types_id_in"
            )
            label(
              v-bind:for="type.id",
              v-bind:data-on-label="type.name",
              v-bind:data-off-label="type.name"
            )
              | {{ type.name }} ({{ type.indices_count }})
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";

export default {
  watch: {
    "query.title_cont": {
      handler(val, old) {
        this.stopScroll();
        this.toggleLoading();
        this.$store.commit("setKeywords", val);
        window.setTimeout(() => {
          this.$store.dispatch("fetchIndices", {
            page: this.page,
            query: this.query,
          });
          this.toggleLoading();
        }, 1000);
      },
      deep: true,
    },
    taxonomy: {
      handler(val, old) {
        this.stopScroll();
        this.toggleLoading();
        if (this.$router.history.current.path == "/design-base/inquiry") {
          this.$router.push({ path: "/design-base" });
        }
        this.updateTaxonomies(val);
        window.setTimeout(() => {
          this.fetchIndices({ page: this.page, query: this.query });
          this.toggleLoading();
        }, 1000);
      },
    },
  },
  computed: {
    places_id_in: {
      get() {
        return this.$store.state.places_id_in;
      },
      set(value) {
        this.$store.commit("setPlace", value.flat());
      },
    },
    categories_id_in: {
      get() {
        return this.$store.state.categories_id_in;
      },
      set(value) {
        this.$store.commit("setCategory", value);
      },
    },
    types_id_in: {
      get() {
        return this.$store.state.types_id_in;
      },
      set(value) {
        this.$store.commit("setType", value);
      },
    },
    colors_id_in: {
      get() {
        return this.$store.state.colors_id_in;
      },
      set(value) {
        this.$store.commit("setColor", value);
      },
    },
    taxonomy() {
      return [
        this.places_id_in,
        this.categories_id_in,
        this.colors_id_in,
        this.types_id_in,
      ];
    },
    ...mapState(["query", "taxonomies"]),
  },
  methods: {
    ...mapActions(["fetchIndices"]),
    ...mapMutations([
      "updateTaxonomies",
      "unsetTaxonomies",
      "toggleLoading",
      "toggleScroll",
      "stopScroll",
    ]),
    navigate() {
      this.unsetTaxonomies();
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../../../assets/stylesheets/variables";

.onoffswitch {
  position: absolute;
  right: 280px;
  width: 40px;
  @media only screen and( max-width: $tablet) {
    right: 16px;
  }
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.onoffswitch-checkbox {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 20px;
}
.onoffswitch-inner {
  display: block;
  width: 100%;
  height: 14px;
  background-color: var(--switchInnerColor);
}
.onoffswitch-inner:before,
.onoffswitch-inner:after {
  display: block;
  font-family: "Lato";
  font-weight: bold;
  box-sizing: border-box;
}
.onoffswitch-inner:before {
  content: "";
  padding-left: 40px;
  color: #888;
}
.onoffswitch-switch {
  display: block;
  width: 18px;
  height: 18px;
  // margin: 6px;
  background: #ffffff;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  // right: 56px;
  // border: 2px solid #999999;
  border-radius: 20px;
  transition: all 0.2s ease;
  box-shadow: 0 0 2px rgb(0 0 0 / 30%);
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
  &:before {
    content: "";
    padding-left: 0px;
  }
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
  transform: translateX(20px);
  transition: all 0.2s ease;
}

.header {
  width: 100%;
  height: 130px;
  background: var(--primaryBackground);
  letter-spacing: 0.1rem;
  position: fixed;
  top: 0;
  z-index: 9998;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  &__inner {
    height: 80px;
    margin: 0 auto;
    padding: 0 24px;
    border-bottom: 1px solid var(--primaryBorder);
    display: flex;
    align-items: center;
    position: relative;
    @media only screen and( max-width: $tablet) {
      width: 100%;
      height: 80px;
      padding: $space-m;
      flex-wrap: wrap;
      justify-content: flex-start;
    }
    ul {
      display: flex;
      li {
        position: relative;
      }
    }
  }
  &__logo {
    font-family: "Lato", sans-serif;
    font-size: 24px;
    font-weight: bold;
    align-content: center;
    a {
      text-decoration: none;
      color: var(--primaryColor);
      @media only screen and( max-width: $tablet) {
        display: flex;
      }
    }
    span {
      margin-top: 4px;
      font-family: "EB Garamond", serif;
      display: block;
      font-size: 12px;
      letter-spacing: 0;
      color: #a0a0a0;
      font-weight: 500;
      @media only screen and( max-width: $tablet) {
        margin-top: 0px;
        margin-left: 6px;
      }
      em {
        margin-left: 4px;
        color: var(--primaryColor);
        @media only screen and( max-width: $tablet) {
          margin-left: 0;
          display: block;
        }
      }
    }
  }
  &__description {
    padding-left: $space-m;
    font-size: 12px;
    color: var(--secondaryColor);
    @media only screen and( max-width: $tablet) {
      font-size: 10px;
      padding-left: 0;
      width: 100%;
      text-align: left;
    }
  }
  &-nav {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    @media only screen and( max-width: $tablet) {
      display: none;
    }
    &__search {
      margin-left: 16px;
      display: flex;
      position: relative;
      border-bottom: 1px solid #666;
      & > .search {
        width: 220px;
      }
    }
  }
  &-filter {
    height: 50px;
    line-height: 50px;
    & > ul {
      padding: 0 8px;
      display: flex;
      position: relative;
      & > li {
        width: 70px;
        // padding-right: 16px;
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        // position: relative;
        color: var(--primaryColor);
        & > .selected {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          & > i {
            margin-left: 6px;
            transition: all 0.3s;
          }
          & > span {
            position: absolute;
            top: 30%;
            transform: translateY(-50%);
            right: 6px;
            width: 16px;
            height: 16px;
            padding-left: 1px;
            border-radius: 100%;
            background: $bg-secondary;
            color: #fff;
            font-size: 10px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        &:hover {
          // padding-right: 0;
          .menu {
            visibility: visible;
            opacity: 1;
            @media only screen and( max-width: $tablet) {
              overflow-y: scroll;
              bottom: 0;
            }
          }
          & > .selected {
            & > i {
              transform: translateY(2px);
              transition: all 0.3s;
            }
          }
        }
        .menu {
          width: 100%;
          padding: $space-m;
          visibility: hidden;
          transition: all 0.3s;
          opacity: 0;
          position: absolute;
          top: 50px;
          left: 0;
          right: 0;
          background: var(--primaryBackground);
          line-height: 1;
          @media only screen and( max-width: $tablet) {
            position: fixed;
            top: 130px;
          }
          input {
            display: none;
            &:checked {
              & + label {
                // background-color: #106b6f;
                background-color: var(--switchTagOn);
                transition: all 0.2s;
                color: var(--switchTagColorOn);
                span {
                  color: #fff;
                }
              }
            }
            & + label {
              color: var(--switchTagColorOff);
              font-weight: bold;
              text-align: left;
              cursor: pointer;
              font-size: 12px;
              padding: 5px 10px;
              // border: 1px solid #434343;
              border-radius: 10px;
              display: inline-block;
              margin-bottom: 10px;
              margin-right: 10px;
              transition: all 0.2s;
              background: var(--switchTagOff);
              transition: all 0.2s;
              span {
                color: #0056b3;
                font-weight: bold;
                margin-right: 2px;
              }
            }
          }
          .form-group {
            display: inline-block;
          }
        }
      }
    }
  }
}

nav {
  text-align: center;
  ul {
    // margin: $space-l 0;
    display: flex;
    justify-content: center;
    li {
      color: #4f4f4f;
      font-weight: bold;
      &:first-child {
        &:before {
          content: "|";
          display: inline-block;
          margin-left: $space-m;
          margin-right: $space-m;
        }
      }
      &:after {
        content: "|";
        display: inline-block;
        margin-left: $space-m;
        margin-right: $space-m;
      }
    }
  }
}
</style>